import type { FacebookInstagramAccount, FacebookPage } from '../api/accounts';

type BrandKey = 'zeelool' | 'vooglam' | string;

const BRAND_ALIASES: Record<'zeelool' | 'vooglam', string[]> = {
  zeelool: ['zeelool', 'zeelooloptical', 'zeeloolglasses'],
  vooglam: ['vooglam', 'vooglams'],
};

const normalizeBrandKey = (brand: BrandKey): 'zeelool' | 'vooglam' | '' => {
  const key = String(brand || '').trim().toLowerCase();
  if (key.includes('vooglam')) return 'vooglam';
  if (key.includes('zeelool')) return 'zeelool';
  return '';
};

const assetSearchText = (item: { name?: string; username?: string; id?: string }) =>
  [item.name, item.username, item.id].filter(Boolean).join(' ').toLowerCase();

const matchesBrand = (text: string, brand: 'zeelool' | 'vooglam') =>
  BRAND_ALIASES[brand].some((alias) => text.includes(alias));

const keepByBrand = (item: { name?: string; username?: string; id?: string }, brand: BrandKey) => {
  const currentBrand = normalizeBrandKey(brand);
  if (!currentBrand) return true;

  const otherBrand = currentBrand === 'zeelool' ? 'vooglam' : 'zeelool';
  const text = assetSearchText(item);
  if (matchesBrand(text, currentBrand)) return true;
  if (matchesBrand(text, otherBrand)) return false;
  return true;
};

export const filterFacebookPagesByBrand = (items: FacebookPage[], _brand: BrandKey) =>
  items;

export const filterFacebookInstagramAccountsByBrand = (items: FacebookInstagramAccount[], brand: BrandKey) =>
  items.filter((item) => keepByBrand(item, brand));

export const pickDefaultFacebookPageID = (items: FacebookPage[], currentID: string, _brand: BrandKey) => {
  if (currentID && items.some((item) => item.id === currentID)) return currentID;
  return items[0]?.id ?? '';
};

export const pickDefaultFacebookInstagramActorID = (items: FacebookInstagramAccount[], currentID: string, _brand: BrandKey) => {
  if (currentID && items.some((item) => item.id === currentID)) return currentID;
  return items[0]?.id ?? '';
};
